export default {
  81: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Membuat penyesuaian kecil terhadap contoh dokumen kurikulum operasional satuan pendidikan yang disediakan oleh Kemendikbudristek.',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Mengembangkan kurikulum operasional satuan pendidikan berdasarkan contoh dokumen kurikulum satuan pendidikan yang disediakan oleh Kemendikbudristek dengan cara memodifikasi bagian pengorganisasian dan perencanaan pembelajaran sesuai kondisi satuan pendidikan, tanpa didasarkan pada refleksi terhadap hasil analisis karakteristik satuan pendidikannya',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Mengembangkan kurikulum satuan pendidikan berdasarkan contoh dari Kemendikbudristek dengan cara memodifikasi pengorganisasian dan perencanaan pembelajaran berdasarkan analisis dan refleksi terhadap kondisi, sarana, prasarana dan tenaga pendidik serta kependidikan di satuan pendidikan dengan melibatkan melibatkan perwakilan siswa, orangtua, atau masyarakat"',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Mengembangkan kurikulum satuan pendidikan yang kontekstual dan sesuai aspirasi warga satuan pendidikan serta hasil analisis dan refleksi diri satuan pendidikan. menstrukturkan pembelajaran sesuai visi-misi dan konteks satuan pendidikan, dengan melibatkan perwakilan peserta didik, orangtua, dan masyarakat',
    },
  ],
  82: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: 'Menggunakan contoh “alur tujuan pembelajaran” yang disediakan oleh Kemendikbudristek',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Melakukan penyesuaian terhadap alur tujuan pembelajaran yang disediakan oleh Kemendikbudristek berdasarkan kebutuhan peserta didik',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Melakukan perombakan terhadap alur tujuan pembelajaran yang disediakan oleh Kemendikbudristek berdasarkan berdasarkan kebutuhan peserta didik',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Mengembangkan “alur tujuan pembelajaran” secara mandiri dengan merujuk pada Capaian Pembelajaran. Koordinator kurikulum di satuan pendidikan memimpin proses perancangan, memonitor implementasi, dan memimpin proses pengembangan dan evaluasi alur tujuan pembelajaran sehingga pengembangan alur tujuan pembelajaran menjadi bagian dari sistem perencanaan dan evaluasi kurikulum satuan pendidikan',
    },
  ],
  83: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: 'Menggunakan contoh perencanaan pembelajaran dan asesmen yang disediakan oleh Kemendikbudristek',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Melakukan penyesuaian terhadap contoh perencanaan pembelajaran dan asesmen yang disediakan oleh Kemendikbudristek berdasarkan kebutuhan peserta didik',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Melakukan perombakan terhadap contoh perencanaan pembelajaran dan asesmen yang disediakan oleh Kemendikbudristek berdasarkan kebutuhan peserta didik',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: 'Melakukan pengembangan perencanaan pembelajaran dan asesmen berdasarkan kebutuhan peserta didik',
    },
  ],
  84: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi: 'Menggunakan buku teks dan modul ajar sebagai sumber utama pengajaran',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Guru dapat memilih materi dari buku teks dan modul ajar, serta bahan ajar lainnya supaya sesuai konteks  lokal dan kebutuhan peserta didik',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru dapat mengkombinasikan berbagai perangkat ajar menyesuaikan dengan konteks lokal dan kebutuhan peserta didik.</li>',
        '<li>Guru dapat memodifikasi beberapa bagian dari modul ajar yang disediakan Kemendikbudristek untuk salah satu atau sebagian materi pelajaran.</li>',
        '</ul>',
      ].join(''),
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi: [
        '<ul style="padding-inline-start: 20px">',
        '<li>Guru dapat mengkombinasikan berbagai perangkat ajar menyesuaikan dengan konteks lokal dan kebutuhan peserta didik.</li>',
        '<li>Guru dapat mengembangkan modul ajar untuk salah satu atau sebagian materi pelajaran, serta berbagi modul ajar yang dibuatnya kepada guru lain.</li>',
        '<li>Satuan pendidikan menyelenggarakan sesi pengembangan modul ajar secara kolaboratif.</li>',
        '</ul>',
      ].join(''),
    },
  ],
  85: [
    {
      label: 'Opsi 1',
      value: 1,
      deskripsi:
        'Menggunakan  modul projek yang disediakan oleh Kemendikbudristek tanpa penyesuaian atau dengan penyesuaian yang sangat sedikit',
    },
    {
      label: 'Opsi 2',
      value: 2,
      deskripsi:
        'Membuat penyesuaian terhadap modul projek yang disediakan oleh Kemendikbudristek sesuai konteks lokal dan kebutuhan peserta didik',
    },
    {
      label: 'Opsi 3',
      value: 3,
      deskripsi:
        'Membuat penyesuaian terhadap  modul projek yang disediakan oleh Kemendikbudristek sesuai konteks lokal, kebutuhan, serta minat peserta didik dengan melibatkan  pendapat dan ide-ide peserta didik',
    },
    {
      label: 'Opsi 4',
      value: 4,
      deskripsi:
        'Mengembangkan ide dan modul projek sesuai konteks lokal, kebutuhan, serta minat peserta didik dengan melibatkan pendapat dan ide-ide peserta didik',
    },
  ],
};
